import React from "react";
import ScrollUp from "react-scroll-up";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowAltCircleUp } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import Navbar from "../../Components/Header/Nav";
import Footer from "../../Components/Footer/index";

const scrollStyle = {
  bottom: "10px",
  right: "10px",
 }
export default function render({ head, body, elementHead, footer }) {
  return (
  <React.Fragment>    
    {head || <Navbar />}
    <div>{elementHead || ""}</div>
    <div className="App-intro">
      {body || ""}
    </div>
    <ScrollUp showUnder={600} style={scrollStyle}>
      <span className="back-to--top" aria-label="Back to Top">
        Back to Top <FontAwesomeIcon icon={faArrowAltCircleUp} size="1x" />
      </span>
    </ScrollUp>
    {footer || <Footer />}
  </React.Fragment>
  )
}

render.propTypes = {
  body: PropTypes.element.isRequired,
  head: PropTypes.element,
  elementHead: PropTypes.element,
};



// WEBPACK FOOTER //
// ./src/Components/Layout/index.js